<template>
  <div class="search-mode-switch" role="group" aria-label="搜索模式">
    <button type="button" :class="{ selected: !smart }" @click="$emit('change', false)">常规搜索</button>
    <button type="button" :class="{ selected: smart }" @click="$emit('change', true)">
      <i class="iconfont icon-ai-stars" />
      AI搜酒店 <span class="trial">试用</span></button>
  </div>
</template>

<script>
export default {
  props: {smart: {type: Boolean, default: false}}
}
</script>

<style scoped>
.search-mode-switch {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 1px solid #fff;
  border-radius: 24px;
  background: rgba(255, 255, 255, .4);
  white-space: nowrap;
}

.search-mode-switch, .search-mode-switch button, .search-mode-switch span {
  font-family: '苹方', 'PingFang SC', sans-serif !important;
}

.search-mode-switch button {
  border: 0;
  background: transparent;
  color: #667085;
  font-size: 12px;
  padding: 9px 14px;
  border-radius: 20px;
  cursor: pointer;
  line-height: 16px;
}

.search-mode-switch .selected {
  background: #fff;
  color: #2454ff;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(31, 49, 90, .08);
}

.sparkle {
  font-size: 16px;
  color: #2454ff;
  margin-right: 3px;
}

.trial {
  background: #12afe0;
  color: #fff;
  border-radius: 3px;
  padding: 0 3px;
  font-size: 10px;
  margin-left: 3px;
}

button:focus-visible {
  outline: 2px solid #2454ff;
  outline-offset: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/smartHotelSearch/SearchModeSwitch.vue